import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationStickerBell = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationStickerBell"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M63.758 48.82c-2.373-3.415-2.98-7.688-1.628-11.42 4.548-12.546.46-18.983-2.248-23.245-1.058-1.662-1.889-2.977-1.832-4.02a5.17 5.17 0 0 0-2.773-4.861l-.378-.197a5.16 5.16 0 0 0-5.572.552c-.816.65-2.373.733-4.34.831-5.04.26-12.657.65-20.257 11.62-.174.25-.36.488-.548.726L19.377 5.244 15.459 6.63l4.182 11.806-4.64-4.787-2.987 2.89 6.082 6.275a13.3 13.3 0 0 1-3.627.548c-5.44.056-9.633 2.425-12.134 6.856l-1.062 1.878s3.212 4.956 8.323 9.067c5.077 4.083 12.365 8.503 20.366 12.636l.555.284c-.385 3.895 1.587 7.82 5.27 9.724a9.86 9.86 0 0 0 4.503 1.095 9.8 9.8 0 0 0 7.337-3.271c9.765 4.858 16.64 3.003 16.64 3.003l.919-1.953c2.168-4.601 1.673-9.395-1.428-13.86"
      />
      <path
        fill="#00D296"
        d="M4.148 31.216c2.554-4.53 6.69-5.761 10.344-5.8 4.749-.048 9.24-2.273 11.945-6.176C36.736 4.375 46.41 10.578 50.62 7.23a3.07 3.07 0 0 1 3.324-.332l.378.197A3.07 3.07 0 0 1 55.976 10c-.295 5.368 10.362 9.67 4.2 26.67-1.616 4.466-.834 9.415 1.874 13.317 2.086 3.004 3.472 7.088 1.258 11.795z"
      />
      <path
        fill="#FE813C"
        d="M40.31 62.802a7.76 7.76 0 1 0 0-15.52 7.76 7.76 0 0 0 0 15.52"
      />
      <path
        fill="#1D2124"
        d="m47.208 38.677.222.128.189-.325a167 167 0 0 0-7.597-4.166 168 168 0 0 0-7.216-3.521l-.158.343a175 175 0 0 1 7.2 3.514 170 170 0 0 1 5.897 3.188c.495.278.98.56 1.463.838"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="m63.395 62.035-.174-.09-.009-.006c-1.297 1.777-7.628.642-16.225-2.58a7.9 7.9 0 0 1-4.264 3.258 8 8 0 0 1-2.422.378 7.9 7.9 0 0 1-3.638-.892c-3.369-1.742-4.968-5.57-4.038-9.093q-.89-.447-1.788-.911C14.802 43.815 2.995 34.655 4.073 31.393l-.19-.098.094-.17c2.18-3.865 5.712-5.848 10.506-5.897 4.772-.05 9.18-2.327 11.79-6.097C33.348 8.923 40.125 8.575 45.078 8.322c2.304-.117 4.129-.211 5.42-1.243a3.26 3.26 0 0 1 3.53-.35l.377.196a3.27 3.27 0 0 1 1.757 3.082c-.09 1.645.88 3.178 2.11 5.117l.018.03c2.656 4.185 6.29 9.912 2.061 21.577-1.564 4.31-.869 9.225 1.851 13.143 2.735 3.936 3.162 7.967 1.273 11.98zm-26.77-21.14c15.127 7.814 26.49 16.41 26.823 20.096 1.461-3.648.94-7.309-1.549-10.898-2.792-4.02-3.502-9.063-1.896-13.487 4.166-11.498.586-17.139-2.029-21.256v-.001l-.005-.008c-1.222-1.923-2.277-3.583-2.178-5.353a2.88 2.88 0 0 0-1.553-2.723l-.378-.197a2.89 2.89 0 0 0-3.12.31C49.353 8.48 47.385 8.583 45.103 8.7c-4.873.25-11.545.593-18.511 10.646-2.682 3.868-7.204 6.21-12.096 6.26-4.369.043-7.657 1.74-9.787 5.045 3.191-1.869 16.782 2.426 31.916 10.244m3.695 6.577a7.59 7.59 0 0 0-6.74 4.095c-1.914 3.71-.456 8.285 3.254 10.204a7.51 7.51 0 0 0 5.776.487 7.53 7.53 0 0 0 4.427-3.74 7.52 7.52 0 0 0 .488-5.776 7.53 7.53 0 0 0-3.74-4.428 7.56 7.56 0 0 0-3.465-.842"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="m18.222 7.63-.356.126 4.056 11.448.356-.126zM14.96 16.298l-.27.263 5.25 5.418.272-.263z"
      />
    </svg>
  );
};
export default IllustrationStickerBell;
